























































































































import { Component, Prop, Vue, Mixins } from "vue-property-decorator";
import LineItem from "./LineItem.vue";
import * as types from "../types/types";
import TrustMessages from "./TrustMessages.vue";
import { editorUrl } from "../util/config";
import checkIfBlackFriday from "../providers/isBlackFriday";
import { formatCurrency } from "@/util/getCurrency";
@Component({
  components: {
    LineItem,
    TrustMessages,
  },
})
export default class Cart extends Vue {
  @Prop() lineItems!: types.LineItem[];
  @Prop() checkoutURL!: string;
  @Prop() lineItemsLoaded!: boolean;
  @Prop() deliveryExpectation?: string;
  @Prop() madeIn?: string;
  @Prop() deliveryHighlighting!: string;

  discount: number = 0;
  isBlackFriday: boolean | null = null;

  formatCurrency = formatCurrency;

  lineItemFinalPrice(l: types.LineItem, eur = false): number {
    const lineItemDiscount = +l.discountPercent || 0;
    if (eur) {
      return l.price * (1 - lineItemDiscount);
    } else {
      return l.priceInUserCurrency * (1 - lineItemDiscount);
    }
  }
  get newPosterUrl() {
    return editorUrl;
  }
  get cartUndiscountedSum() {
    return this.lineItems
      .map((l) => this.lineItemFinalPrice(l))
      .reduce((a, b) => a + b, 0);
  }
  get cartDiscountedSum() {
    return this.discountedSum();
  }
  get cartIsEmpty() {
    return this.lineItemsLoaded && this.lineItems.length === 0;
  }
  get mainMobilePurchaseArgument() {
    return {
      title: this.$t("moneyBack.title"),
      subheadline: this.$t("moneyBack.teaser"),
    };
  }
  discountedSum(eur = false) {
    return (
      this.lineItems
        .map((l) => this.lineItemFinalPrice(l, eur))
        .reduce((a, b) => a + b, 0) *
      (1 - (this.discount || 0))
    );
  }
  goToEditor() {
    window.location.href = editorUrl;
  }

  checkScroll() {
    const cartSideElement = document.querySelector(".cart-side-element");
    if (!cartSideElement) {
      return;
    }
    let box = cartSideElement.getBoundingClientRect();
    if (box.top < window.innerHeight) {
      document.querySelector(".mobile-cta").classList.add("disabled");
    } else {
      document.querySelector(".mobile-cta").classList.remove("disabled");
    }
  }
  mounted() {
    window.addEventListener("scroll", this.checkScroll);
    checkIfBlackFriday().then((isIt) => (this.isBlackFriday = isIt));
    // this.getAbTestStatus();
  }
}
